var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "add_supplier",
      attrs: {
        visible: _vm.dialogVisible,
        "append-to-body": true,
        title: _vm.dialogTitle,
        width: "700px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "supplier" },
        [
          _vm.type === "edit"
            ? _c("div", { staticClass: "supplier-form" }, [
                _vm._v(" 供应商编码：" + _vm._s(_vm.form.supplierCode) + " "),
              ])
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "supplierForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 32,
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商分类", prop: "category" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                "default-first-option": "",
                              },
                              model: {
                                value: _vm.form.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "category", $$v)
                                },
                                expression: "form.category",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.supplier_category,
                              function (item, index) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    value: item.dictName,
                                    label: item.dictName,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 30,
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.contactPerson,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactPerson", $$v)
                              },
                              expression: "form.contactPerson",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系号码" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 20,
                              clearable: "",
                              placeholder: "请输入",
                              oninput:
                                "if (/\\D/g.test(this.value)) this.value = this.value.replace(/\\D/g,'')",
                            },
                            model: {
                              value: _vm.form.contactNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "contactNumber", $$v)
                              },
                              expression: "form.contactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱地址" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 100,
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "结算期限" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                "default-first-option": "",
                              },
                              model: {
                                value: _vm.form.settlementPeriod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "settlementPeriod", $$v)
                                },
                                expression: "form.settlementPeriod",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.settlement_period,
                              function (item, index) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "信用额度" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "20",
                              oninput:
                                "if (/\\D/g.test(this.value)) this.value = this.value.replace(/\\D/g,'')",
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.creditLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "creditLimit", $$v)
                              },
                              expression: "form.creditLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发票抬头" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.invoiceHeader,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "invoiceHeader", $$v)
                              },
                              expression: "form.invoiceHeader",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "开户银行" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.bankName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bankName", $$v)
                              },
                              expression: "form.bankName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "收款账号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 30,
                              clearable: "",
                              oninput:
                                "if (/\\D/g.test(this.value)) this.value = this.value.replace(/\\D/g,'')",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.bankAccountNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bankAccountNumber", $$v)
                              },
                              expression: "form.bankAccountNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商地址" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 100,
                              clearable: "",
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "address", $$v)
                              },
                              expression: "form.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              clearable: "",
                              rows: 2,
                              maxlength: 64,
                              placeholder: "请输入",
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.submitForm },
            },
            [_vm._v("确定")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }